import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SubArrowIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Sub Arrow`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 2v6h13m0 0-4-4m4 4-4 4"
      fill="none"
    />
  </Icon>
);
